import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  required,
  email,
  length,
  min,
  min_value,
  max,
  max_value,
  size,
  confirmed,
  ext,
  numeric,
  alpha,
  alpha_dash,
  alpha_spaces,
  digits,
  regex,
  double
} from 'vee-validate/dist/rules'
import { localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import en from 'vee-validate/dist/locale/en.json'

import store from '@/store/index'
import { i18n } from '@/plugins/i18n'


// Add rules
extend('required', required)
extend('email', email)
extend('length', length)
extend('min_value', min_value)
extend('min', min)
extend('max_value', max_value)
extend('max', max)
extend('ext', ext)
extend('size', size)
extend('numeric', numeric)
extend('confirmed', confirmed)
extend('alpha', alpha)
extend('alpha_spaces', alpha_spaces)
extend('digits', digits)
extend('regex', regex)
extend('double', double)
extend('alpha_dash', alpha_dash)
extend('alpha_special', {
  validate(value) {
    const pattern = /^[a-zA-Z0-9\s.\-_@,]+$/
    return pattern.test(value)
  },
  message: (fieldName) =>
    i18n.t('validation.alpha_special', { fieldName })
})

localize('es', es)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
